const ths = [
  {
    id: 1,
    label: 'ID',
    sortable: false
  },
  {
    id: 2,
    label: 'First name',
    sortable: false
  },
  {
    id: 3,
    label: 'Last name',
    sortable: false
  },
  {
    id: 4,
    label: 'Previous Level',
    sortable: false
  },
  {
    id: 5,
    label: 'Current Level',
    sortable: false
  },
  {
    id: 6,
    label: 'Registration Date',
    sortable: false
  },
  {
    id: 7,
    label: 'Award duration',
    sortable: false
  },
  {
    id: 8,
    label: 'Activity Detail',
    sortable: false
  },
  {
    id: 9,
    label: 'Action',
    sortable: false
  }
]

export default ths
